import React, { useState, useEffect } from "react";
import { Modal, Table, Input } from "antd";

const HSOrderDetailModal = ({ isVisible, onClose, orderDetail }) => {
  const [dataSource, setDataSource] = useState([]);

  // orderDetail이 변경될 때마다 dataSource 초기화
  useEffect(() => {
    if (orderDetail) {
      const updatedItems = (orderDetail.itemList || []).map((item, index) => ({
        ...item,
        no: item.no || index + 1, // no 필드가 없으면 자동 생성
      }));
      setDataSource(updatedItems);
    }
  }, [isVisible,orderDetail]);

  // 값 변경 핸들러
  const handleInputChange = (value, recordNo, dataIndex) => {
    const newData = dataSource.map((item) => {
      if (item.no === recordNo) {
        // 해당 행만 업데이트
        return { ...item, [dataIndex]: value };
      }
      return item;
    });
    setDataSource(newData); // 상태 업데이트
  };

  // 수정 가능한 컬럼 정의
  const ItemTablecolumns = [
    {
      title: "제품명",
      dataIndex: "itemName",
      key: "itemName",
      align: "center",
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) =>
            handleInputChange(e.target.value, record.no, "itemName")
          }
        />
      ),
    },
    {
      title: "원단코드",
      dataIndex: "fabicCode",
      key: "fabicCode",
      align: "center",
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) =>
            handleInputChange(e.target.value, record.no, "fabicCode")
          }
        />
      ),
    },
    {
      title: "샤시코드",
      dataIndex: "sashCode",
      key: "sashCode",
      align: "center",
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) =>
            handleInputChange(e.target.value, record.no, "sashCode")
          }
        />
      ),
    },
    {
      title: "수량",
      dataIndex: "quantity",
      key: "quantity",
      align: "center",
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) =>
            handleInputChange(e.target.value, record.no, "quantity")
          }
        />
      ),
    },
  ];
  return (
    <Modal
      title="주문 상세 정보"
      open={isVisible}
      onOk={() => {
       // 수정된 데이터를 부모 컴포넌트로 전달
        const updatedOrderDetail = { ...orderDetail, itemList: dataSource };
        onClose(updatedOrderDetail); // 수정된 데이터를 전달
      }}
      onCancel={() => {
        const resetData = (orderDetail.itemList || []).map((item, index) => ({
            ...item,
            no: item.no || index + 1,
          }));
          //setDataSource(resetData); // 데이터 초기화
        onClose(); // 모달 닫기
      }}
      style={{ zIndex: 1050 }}
      getContainer={false}
      width={1200}
      styles={{
        body: { overflowY: "auto", maxHeight: "70vh" }, // bodyStyle 대신 styles 사용
      }}
    >
      {orderDetail ? (
        <div>
          <label style={{ display: "block", marginTop: "10px" }}>
            주문 번호 : {orderDetail.orderCode}
          </label>
          <label style={{ display: "block", marginTop: "10px" }}>
            수취인 : {orderDetail.recipient}
          </label>
          <label style={{ display: "block", marginTop: "10px" }}>
            주소 : {orderDetail.address.split("/")[1]}
          </label>
          <Table
            columns={ItemTablecolumns}
            dataSource={dataSource}
            pagination={false}
            style={{ margin: "20px" }}
            rowKey="no" // 고유 키로 설정
          />
        </div>
      ) : (
        <p>주문 상세 데이터가 없습니다.</p>
      )}
    </Modal>
  );
};

export default HSOrderDetailModal;